import { render, staticRenderFns } from "./reviewStatus.vue?vue&type=template&id=7b346784&scoped=true"
import script from "./reviewStatus.vue?vue&type=script&lang=js"
export * from "./reviewStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b346784",
  null
  
)

export default component.exports